import { CloseIcon } from "@/components/features/SquadBuilder/RightPanel/PanelHeader/PanelHeader";
import { cn } from "@/lib/utils";
import { BREAKPOINTS } from "@/settings";

export const CURRENT_FEATURE_INDEX = 5;

export const FeaturesBanner = ({ onClose }: { onClose: () => void }) => {
  return (
    <div
      className={cn(
        "flex flex-row justify-center p-2 text-xs desktop:text-sm bg-primary-dark-blue text-white sticky top-0 w-full z-40",
      )}
    >
      <div className="flex flex-row justify-between w-full text-center">
        <div />
        <div className="text-white/80">
          🚀 FC 26 top 100 players are now live! Explore them{" "}
          <a
            href="https://www.easysbc.io/players"
            className="text-white/80 underline font-bold"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </div>
        <span
          className="my-auto cursor-pointer fill-gray-800"
          onClick={onClose}
        >
          <CloseIcon color="white" />
        </span>
      </div>
    </div>
  );
};
